import { Loader } from '@aws-amplify/ui-react';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import React, { Fragment, JSX } from 'react';

interface StateProps {
  sessionId?: string;
  loading: boolean;
}

interface DispatchProps {
  onAnalysisComplete: () => Promise<void>;
  onError: (livenessError: unknown) => void;
}

type Props = StateProps & DispatchProps;
export const FaceLivenessDetectorScreen: React.FC<Props> = ({
  loading,
  sessionId,
  onAnalysisComplete,
  onError,
}): JSX.Element =>
  loading ? (
    <Loader />
  ) : (
    <Fragment>
      {sessionId && (
        <div className="event w-full container mx-auto mb-36 lg">
          <FaceLivenessDetector
            sessionId={sessionId}
            region="us-east-1"
            displayText={{
              cameraMinSpecificationsHeadingText: 'A câmera não atende às especificações mínimas',
              cameraMinSpecificationsMessageText:
                'A câmera deve suportar pelo menos resolução 320*240 e 15 quadros por segundo.',
              cameraNotFoundHeadingText: 'A câmera não está acessível.',
              cameraNotFoundMessageText:
                'Verifique se há uma câmera conectada e se não há outro aplicativo usando a câmera. Talvez seja necessário acessar as configurações para conceder permissões à câmera, fechar todas as instâncias do navegador e tentar novamente.',
              a11yVideoLabelText: 'Webcam para verificação de atividade',
              cancelLivenessCheckText: 'Cancelar verificação de atividade',
              goodFitCaptionText: 'Bom ajuste',
              goodFitAltText:
                'Ilustração do rosto de uma pessoa, perfeitamente encaixado dentro de um oval.',
              hintCenterFaceText: 'Centralize seu rosto',
              hintCenterFaceInstructionText:
                'Instruções: Antes de iniciar a verificação, certifique-se de que sua câmera esteja no centro da tela e centralize seu rosto em relação à câmera. Quando a verificação começar, uma oval aparecerá no centro. Você será solicitado a avançar para a oval e, em seguida, a ficar parado. Após alguns segundos, você ouvirá a verificação concluída.',
              hintFaceOffCenterText:
                'O rosto não está no oval, centralize seu rosto em relação à câmera.',
              hintMoveFaceFrontOfCameraText: 'Mover o rosto na frente da câmera',
              hintTooManyFacesText:
                'Certifique-se de que apenas um rosto esteja na frente da câmera',
              hintFaceDetectedText: 'Rosto detectado',
              hintCanNotIdentifyText: 'Mover o rosto na frente da câmera',
              hintTooCloseText: 'Afaste-se',
              hintTooFarText: 'Chegue mais perto',
              hintConnectingText: 'Conectando...',
              hintVerifyingText: 'Verificando...',
              hintCheckCompleteText: 'Verificação completa',
              hintIlluminationTooBrightText: 'Vá para uma área mais escura',
              hintIlluminationTooDarkText: 'Vá para uma área mais clara',
              hintIlluminationNormalText: 'Condições de iluminação normais',
              hintHoldFaceForFreshnessText: 'Fique parado',
              hintMatchIndicatorText: '50% concluído. Continue se aproximando.',
              photosensitivityWarningBodyText:
                'Este teste pisca em cores diferentes. Tenha cuidado se você for fotossensível.',
              photosensitivityWarningHeadingText: 'Aviso de fotossensibilidade',
              photosensitivityWarningInfoText:
                'Algumas pessoas podem ter crises epilépticas quando expostas a luzes coloridas. Tenha cuidado se você ou alguém da sua família tiver problemas de epilepsia.',
              photosensitivityWarningLabelText: 'Mais informações sobre fotossensibilidade',
              photosensitivyWarningBodyText:
                'Este teste pisca em cores diferentes. Tenha cuidado se você for fotossensível.',
              photosensitivyWarningHeadingText: 'Aviso de fotossensibilidade',
              photosensitivyWarningInfoText:
                'Algumas pessoas podem ter crises epilépticas quando expostas a luzes coloridas. Tenha cuidado se você ou alguém da sua família tiver problemas de epilepsia.',
              photosensitivyWarningLabelText: 'Mais informações sobre fotossensibilidade',
              retryCameraPermissionsText: 'Tentar novamente',
              recordingIndicatorText: 'Gravação',
              startScreenBeginCheckText: 'Iniciar verificação de vídeo',
              tooFarCaptionText: 'Longe demais',
              tooFarAltText:
                'Ilustração do rosto de uma pessoa dentro de uma oval; há um espaço entre o perímetro do rosto e os limites da oval.',
              waitingCameraPermissionText: 'Aguardando sua permissão para usar a câmera.',
              errorLabelText: 'Erro',
              connectionTimeoutHeaderText: 'Tempo limite de conexão',
              connectionTimeoutMessageText: 'A conexão expirou.',
              timeoutHeaderText: 'Tempo esgotado',
              timeoutMessageText:
                'O rosto não coube dentro do oval dentro do tempo limite. Tente novamente e preencha completamente o oval com o rosto.',
              faceDistanceHeaderText: 'Movimento para frente detectado',
              faceDistanceMessageText: 'Evite se aproximar ao conectar.',
              multipleFacesHeaderText: 'Vários rostos detectados',
              multipleFacesMessageText:
                'Certifique-se de que apenas um rosto esteja presente na frente da câmera ao conectar.',
              clientHeaderText: 'Erro do cliente',
              clientMessageText: 'A verificação falhou devido a um problema do cliente',
              serverHeaderText: 'Problema no servidor',
              serverMessageText:
                'Não é possível concluir a verificação devido a um problema no servidor',
              landscapeHeaderText: 'Orientação paisagem não suportada',
              landscapeMessageText: 'Gire seu dispositivo para a orientação retrato (vertical).',
              portraitMessageText:
                'Certifique-se de que seu dispositivo permaneça na orientação retrato (vertical) durante toda a verificação.',
              tryAgainText: 'Tentar novamente',
            }}
            // disableInstructionScreen={true}
            /* config={{
                      binaryPath: '/faces/wasm',
                      faceModelUrl: '/faces/model/model.json',
                    }}
                      */
            onAnalysisComplete={onAnalysisComplete}
            onError={onError}
          />
        </div>
      )}
    </Fragment>
  );
